import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-20627b4a"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "audience-selector" };
const _hoisted_2 = { class: "audience-selector__list" };
import { useAudiences } from "src/shared/store/audience/composables";
import { useFuzzySearch } from "src/shared/store/common/fuzzy-search";
import SearchBar from "src/shared/v-components/ui/search/SearchBar.vue";
import { computed, ref } from "vue";
import AudienceSelectorItem from "./AudienceSelectorItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AudienceSelector',
    props: {
        audienceId: {},
        audienceIds: {},
        isReadonly: { type: Boolean },
        isMultiple: { type: Boolean }
    },
    emits: ["update:audienceId", "update:audienceIds"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const singleValueProxy = computed({
            get() {
                var _a;
                return (_a = props.audienceId) !== null && _a !== void 0 ? _a : null;
            },
            set(value) {
                emit("update:audienceId", value);
            },
        });
        const multipleValueProxy = computed({
            get() {
                var _a;
                return (_a = props.audienceIds) !== null && _a !== void 0 ? _a : [];
            },
            set(value) {
                emit("update:audienceIds", value);
            },
        });
        const search = ref("");
        const { audiences } = useAudiences();
        const filteredAudiences = useFuzzySearch(search, audiences, ["name"]);
        const toggleSelectionOfAudience = (audienceIdToToggle) => {
            if (props.isMultiple) {
                const currentIds = [...multipleValueProxy.value];
                const index = currentIds.indexOf(audienceIdToToggle);
                if (index > -1) {
                    currentIds.splice(index, 1);
                }
                else {
                    currentIds.push(audienceIdToToggle);
                }
                multipleValueProxy.value = currentIds;
            }
            else {
                if (singleValueProxy.value === audienceIdToToggle) {
                    singleValueProxy.value = null;
                }
                else {
                    singleValueProxy.value = audienceIdToToggle;
                }
            }
        };
        const isSelected = (audienceIdToCheck) => {
            if (props.isMultiple) {
                return multipleValueProxy.value.includes(audienceIdToCheck);
            }
            else {
                return singleValueProxy.value === audienceIdToCheck;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" Search input "),
                (!_ctx.isReadonly)
                    ? (_openBlock(), _createBlock(SearchBar, {
                        key: 0,
                        search: search.value,
                        "onUpdate:search": _cache[0] || (_cache[0] = ($event) => ((search).value = $event))
                    }, null, 8 /* PROPS */, ["search"]))
                    : _createCommentVNode("v-if", true),
                _createCommentVNode(" Available audiences list "),
                _createElementVNode("ul", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredAudiences), (audience) => {
                        return (_openBlock(), _createBlock(AudienceSelectorItem, {
                            key: audience.id,
                            audience: audience,
                            isSelected: isSelected(audience.id),
                            onToggleSelection: ($event) => (toggleSelectionOfAudience(audience.id)),
                            isReadonly: _ctx.isReadonly,
                            isMultiple: _ctx.isMultiple
                        }, null, 8 /* PROPS */, ["audience", "isSelected", "onToggleSelection", "isReadonly", "isMultiple"]));
                    }), 128 /* KEYED_FRAGMENT */))
                ])
            ]));
        };
    }
});
